module.exports = __webpack_public_path__ + "static/media/shuttler.f747a84a.png";